 

import React, { useCallback, useContext, useEffect, useMemo, useRef, useState } from "react";
import { AgGridReact } from "ag-grid-react";
import {  ColDef, ColumnResizedEvent, ColumnVisibleEvent, GridOptions, GridReadyEvent, IDatasource, IGetRowsParams,  PaginationChangedEvent, SortChangedEvent, themeQuartz,} from "ag-grid-community";
import { IAGGridDataTableEngineProps, } from "./shared/interface";
import loader from './assets/loader4.gif';
import noDeviceAvailable from "./assets/noDeviceAvailable.png";
import "ag-grid-community/styles/ag-theme-quartz.css"; 
import { GenericDassQuery } from "../../../services/BasicDassQueries";
import './AGGridDataTableEngine.css';
import '../DataTable.css';
import '@fortawesome/fontawesome-pro/css/all.min.css';
import { useDataTableContext } from "./shared/Context";
import { toast } from "../../../utils/Toaster";
import { createRoot } from "react-dom/client";
import { pageHasGlobalSearchTagControl } from "../../../pages/PagesConfig";
import DataTableSearchComponent from "../DataTable/DataTableSearchComponent";
import { DataTableContext } from "../DataTable/DataTableState";
import AppContext from "../../../context/AppContext";
import { useLocation } from "react-router";

const AGGridDataTableEngine: React.FC<IAGGridDataTableEngineProps> = ({ columns, fetchUrl, pagination,dataTableOption, refresh, name, exportInit, selectedDevices, defaultFilterQueryParams, selectedFirmware, activeStep }) => {

  const { columnVisible, columnHidden, visibleColumnList,setVisibleColumnList,hiddenColumnList, TableView, setColumnVisible, setColumnHidden, setSelectedRowCount, setGridApi, columnWidthsRef, floatingFilterValueMap, isSelectAllActive, totalEntriesRef, fetchUrlRef,
   queryParamsStringRef, fetchUrlParamsRef, primaryKeyRef, selectedRowData, deSelectedRowData, rowHeight, VIEW_FIELDS_REF, setRowHeight, ROW_HEIGHT_DEFAULT     
  } = useDataTableContext();
  const responseLoadingRef = useRef(false);
  const [tableVersionKey, setTableVersionKey] = useState(0);
  useEffect(() => {
      setRowHeight(ROW_HEIGHT_DEFAULT ?? 35);
      // setTableView(View.Basic);
      // setVisibleColumnList(Array.from(VIEW_FIELDS_REF.current?.[View.Basic] ?? []));
      setVisibleColumnList(Array.from(VIEW_FIELDS_REF.current?.[TableView] ?? []));
      exportInit = 0;
      //  removing the isBulkAction for safe side if user is navigating away from the page without completing the bulk action 
      localStorage.removeItem('isBulkAction'); 
  },[]);
  const paginationPageSizeSelector=[15,25,50,100];
  const pageSize = useRef<number>(paginationPageSizeSelector[2] ?? 50);
  const pageStateArray = useRef<string[]>([]);
  const queryParams = useRef<URLSearchParams>(new URLSearchParams());
  const fetchUrlParams = useRef<URLSearchParams>(new URLSearchParams());
  const [hasColInitialized,setColInitialized] = useState<boolean>(false);
  const gridRef = useRef<AgGridReact>(null);
  const columnDefs = useRef<ColDef[]>([]);
  const searchParamMap = useMemo(() => new Map(), []);
  const sortParamMap = useMemo(() => new Map(), []);
  const lazyLoadParamMap = useMemo(() => new Map(), []);
  const stream = dataTableOption?.query_param?.stream;
  let DataTableContextObj = useContext(DataTableContext);
  let AppContextObj = useContext(AppContext);
 fetchUrlRef.current = fetchUrl;
  const primaryKey = dataTableOption?.available_key;
  primaryKeyRef.current = primaryKey;
  //this code will refresh the table when user will return from detail page after updating or addin any new record
  const { state } = useLocation();

  Object.entries(dataTableOption?.query_param || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      fetchUrlParams.current.set(key, String(value));
      fetchUrlParamsRef.current.set(key, String(value));
    }
  });

  
  useEffect(() => {
    gridRef.current?.api?.setFilterModel(null);
    gridRef.current?.api?.onFilterChanged();
    pageStateArray.current = [];
    totalEntriesRef.current = 0;
    // as when table changes need to reset selectedRowData - for Account, Profile tables where same table is used
    selectedRowData.current.clear();
    deSelectedRowData.current.clear();
    isSelectAllActive.current = false;
    setSelectedRowCount(0);
    queryParams.current = new URLSearchParams();
    fetchUrlParams.current = new URLSearchParams();
    fetchUrlRef.current = fetchUrl;
    floatingFilterValueMap.current = new Map();
    if (dataTableOption?.defaultSortField && dataTableOption?.defaultSortOrder) {
     queryParams.current.set(dataTableOption.defaultSortField, dataTableOption.defaultSortOrder); 
    }
    if( defaultFilterQueryParams && defaultFilterQueryParams instanceof URLSearchParams) {
      defaultFilterQueryParams.forEach((value, key) => {
        queryParams.current.set(key, value);
      });
    }
    DataTableContextObj.setSearchState(prev => ({
        ...prev,
        totalRecords: 0,
        selectedRowIds: [],
        searchFields: {},
    }));
  }, [fetchUrl]);

   let upatedRowkeys = []
    if(state) {
        let updatedRow = state?.hasOwnProperty('updatedRow') ? state['updatedRow'] : {};
        
        if(updatedRow) {
            upatedRowkeys = Object.values(updatedRow);
        }
    }
  

  useEffect(() => {
    const resetStateObj = { refresh: !DataTableContextObj.searchState.refresh }

    DataTableContextObj.setSearchState(prev => {
      return { ...prev, ...resetStateObj }
    })

  }, [upatedRowkeys[0]])



  useEffect(() => {
    try { 
      if (DataTableContextObj?.searchState?.searchFields?.search_tags) {
        queryParams.current.set('search_tags', DataTableContextObj.searchState.searchFields.search_tags);
      } else  {
        queryParams.current.delete('search_tags');
      }

      const Refresh = async () => {
        localStorage.setItem("preservedView", TableView.toString());
        if (gridRef.current?.api) {
          gridRef.current?.api.hideOverlay();
          await fetchPageState();
        }
      }
      Refresh();
    } catch (error) {
      console.error(error);
    }
  }, [refresh, name, DataTableContextObj?.searchState?.searchFields?.search_tags, DataTableContextObj.searchState.refresh]);

  useEffect(() => {
    if ((dataTableOption?.hasOwnProperty('extraSearchProp') || pageHasGlobalSearchTagControl(name)) && document.getElementById("extra-search-box")) {
      const container = document.getElementById("extra-search-box");
      const rootInstance = createRoot(container!);
      rootInstance.render(<DataTableSearchComponent DataTableContextObj={DataTableContextObj} extraSearchProp={dataTableOption.extraSearchProp} AppContextObj={AppContextObj} />);
    }

  }, []);

  useEffect(() => {
    if(exportInit == undefined || exportInit == null) {
      return;
    }
    const resetStateObj = { exportInit: exportInit, dataTableOption: { ...dataTableOption, data: [] } }

    DataTableContextObj.setSearchState(prev => {
      return { ...prev, ...resetStateObj }
    })
  }, [exportInit])
  
  useEffect(() => {
    const makeColumnVisible = async () => {
    try {
      if (columnVisible) {
        const lazyLoadKey = lazyLoadParamMap.get(columnVisible);
        if (lazyLoadKey) {
         await  gridRef?.current?.api?.setGridOption("loading", true); 
          queryParams.current.set(lazyLoadKey, "true"); 
           await fetchPageState();
        } 
        gridRef?.current?.api?.setColumnsVisible([columnVisible], true);  
        setColumnVisible(""); 
      }
    } catch (error) {
      console.error(error);
    }
    }
    makeColumnVisible();
  }, [columnVisible, setColumnVisible]);
  
  useEffect(() => {
    const makeColumnHidden = async () => {    
    try {
      if (columnHidden) {    
        const lazyLoadKey = lazyLoadParamMap.get(columnHidden);
        if (lazyLoadKey) {
          await gridRef?.current?.api?.setGridOption("loading", true); 
          queryParams.current.set(lazyLoadKey, "false");  
          await fetchPageState();  
        }
        gridRef?.current?.api?.setColumnsVisible([columnHidden], false); 
        setColumnHidden(""); 
      }
    } catch (error) {
      console.error(error);
    }
    }
    makeColumnHidden();
  }, [columnHidden, setColumnHidden]);
  
  useEffect(()=>{
    try{
      gridRef?.current?.api?.setColumnsVisible(visibleColumnList, true);     
      gridRef?.current?.api?.setColumnsVisible(hiddenColumnList, false);
    }catch(error){
      console.error(error);
    }   
  },[TableView]);  

  useEffect(() => {
    try {
      const columnInitialize = async()=> {
            columnDefs.current = columns.map((column): ColDef => {
            const { searchingParam, sortingParam, lazyLoadParamKey, backendFilterType, ...agGridSafeColumn } = column;
    
            let isVisible: boolean;
         // let visLst = Array.from(VIEW_FIELDS_REF.current?.[TableView] ?? []);
            let visLst = visibleColumnList.length > 0 ? visibleColumnList : Array.from(VIEW_FIELDS_REF.current?.[TableView] ?? []);
            if (visLst?.length > 0 && column.field) {
              isVisible = visLst?.includes(column.field);
            } else {
              isVisible = column.hide !== true; 
            }

            if (column.field) {
              if (searchingParam) {
                searchParamMap.set(column.field, searchingParam);
              }
              if (sortingParam) {
                sortParamMap.set(column.field, sortingParam);
              }
              if (lazyLoadParamKey) {
                lazyLoadParamMap.set(column.field, lazyLoadParamKey);
                queryParams.current.set(lazyLoadParamKey, isVisible ? "true" : "false"); 
              }

            }

            const baseDef: ColDef = {
              ...agGridSafeColumn,
              field: column.field ?? "",
              headerName: column.headerName ?? "",
              resizable: column.resizable ?? false,
              floatingFilter: Boolean(searchingParam),
              cellRenderer: column.cellRenderer ?? undefined,
              hide: !isVisible,
            };

            return baseDef;

          }); 
          setColInitialized(true);
        } 
        columnInitialize();
    } catch (err) {
      console.error("Column initialization failed", err);
    }
  }, []);

  const fetchPageState = async () => {
    try {
      gridRef?.current?.api.setGridOption("cacheBlockSize", pageSize.current);
      totalEntriesRef.current = 0;
      pageStateArray.current = [];

      if (selectedFirmware?.length > 0 && activeStep === 0) {
      
        selectedRowData.current.clear(); 
        selectedFirmware.forEach(device => {
          const key = device?.[primaryKey];
          if (key) {
            selectedRowData.current.set(key, device);
          }
        });
        DataTableContextObj.setSearchState(prev => ({
          ...prev,
          selectedRowIds: Array.from(selectedRowData.current.keys())
        }));
      }

      else if (selectedDevices?.length > 0 && activeStep === 1) {
        selectedRowData.current.clear(); 
        selectedDevices.forEach(device => {
          const key = device?.[primaryKey];
          if (key) {
            selectedRowData.current.set(key, device);
          }
        });
        DataTableContextObj.setSearchState(prev => ({
          ...prev,
          selectedRowIds: Array.from(selectedRowData.current.keys())
        }));
      }
      else {
        DataTableContextObj.setSearchState(prev => ({
            ...prev,
            totalRecords: totalEntriesRef.current ?? 0,
            selectedRowIds: [],
        }));
      }
      // if required, add in onGridReady event to reset selectedRowData
      // selectedRowData.current = new Set();
      // setSelectedRowCount(0);
      gridRef?.current?.api.setGridOption("loading", false);

      if (stream === 'memory') {
        DataTableContextObj.setSearchState(prev => ({
          ...prev,
          totalRecords: dataTableOption?.data?.length ?? 0,
        }))
      };
      if (stream === 'simple') {
        await gridRef?.current?.api.setGridOption("datasource", dataSource);
      }
     
      if (stream === "progress") {
        fetchUrlParams.current.set("get_pages", String(dataTableOption?.query_param?.get_pages ?? true));
        fetchUrlParams.current.set("limit", pageSize.current.toString());
        fetchUrlParams.current.delete("page_state");
      const fetchUrlParamsString = "?" + ((fetchUrlParams.current.size > 0) ? fetchUrlParams.current.toString() : "");
      const queryParamsString =  (queryParams.current.size > 0) ? `&${queryParams.current}` : "";
      const FETCH_PAGE_STATE_URL = `${fetchUrlRef.current}${fetchUrlParamsString}${queryParamsString}`;
      queryParamsStringRef.current = queryParamsString;
      const response = await GenericDassQuery(FETCH_PAGE_STATE_URL, { method: "GET" });

      fetchUrlParams.current.delete("get_pages");
      fetchUrlParams.current.delete("limit");

      if (response.status) {
        const data = await response.data;

        if (typeof data === "object" && data !== null) {
          totalEntriesRef.current = parseInt(data?.total ?? 0, 10);
           
          DataTableContextObj.setSearchState(prev => ({
            ...prev,
            totalRecords: parseInt(data?.total ?? 0, 10) ?? 0,
            dataTableOption: {},
          }));
          if (data.total === 0) {
            gridRef?.current?.api.setGridOption("datasource", nullDataSource);
            gridRef?.current?.api.setGridOption("cacheBlockSize", 1);
            gridRef?.current?.api?.showNoRowsOverlay();
            gridRef?.current?.api.setGridOption("loading", false);
          }
          else {
            for(const page of data.pages) {
              if (page.page_state) {
                pageStateArray.current.push(page.page_state);
              }
            }
            await gridRef?.current?.api.setGridOption("datasource", dataSource); 
          }
        }
      } else {
        gridRef?.current?.api.setGridOption("datasource", nullDataSource);  
        gridRef?.current?.api.setGridOption("cacheBlockSize", 1);
        gridRef?.current?.api?.showNoRowsOverlay();
        console.error("Error fetching data:", response.status);
      }
      }
    } catch (error) {
      gridRef?.current?.api.setGridOption("datasource", nullDataSource);
      gridRef?.current?.api.setGridOption("cacheBlockSize", 1);
      gridRef?.current?.api?.showNoRowsOverlay();
      gridRef?.current?.api.setGridOption("loading", false);
      toastErrorMessage(error)
    }
  };

    const nullDataSource: IDatasource = {
      rowCount: 0,
      getRows: (params: IGetRowsParams) => {
        params.successCallback([], 0);
      }
    }

  const dataSource: IDatasource = {
    rowCount: totalEntriesRef.current ?? 0,
    getRows: async function (params: IGetRowsParams) {
     try {
      if(stream === "progress"){
        if (pageStateArray.current.length === 0) {
         await gridRef.current?.api.setGridOption("loading", false);
         params.successCallback([], 0);
        } else {
          const currentPageState = pageStateArray.current[params.startRow / pageSize.current];
    
          fetchUrlParams.current.delete("get_pages");
          fetchUrlParams.current.set("limit", pageSize.current.toString());
          fetchUrlParams.current.set("page_state", currentPageState.toString());

          const fetchUrlParamsString = "?" + ((fetchUrlParams.current.size > 0) ? fetchUrlParams.current.toString() : "");
          const queryParamsString =  (queryParams.current.size > 0) ? `&${queryParams.current}` : "";
          
          const REQ_URL = `${fetchUrlRef.current}${fetchUrlParamsString}${queryParamsString}`;

          const response = await GenericDassQuery(REQ_URL, { method: "GET" });
        
          fetchUrlParams.current.delete("page_state");
          fetchUrlParams.current.delete("limit");
        
          if (response.status === 200) {
            const data = await response.data;
            if (Array.isArray(data) && data.length > 0) {   
              data.forEach((row) => {
                  if (dataTableOption.addServiceActions){
                    dataTableOption.actions = dataTableOption.addServiceActions(row);
                  }
                  if (dataTableOption.addBulkServicesActions){
                    dataTableOption.bulkActions = dataTableOption.addBulkServicesActions(row,dataTableOption.bulkActions);   
                  }
                DataTableContextObj.setSearchState(prev => ({
                  ...prev,
                  dataTableOption: dataTableOption,
                }));

              });
              params.successCallback(data, totalEntriesRef.current ?? 0);
              

              setTimeout(() => {
                gridRef.current?.api?.forEachNode((node) => {
                  const key = node.data?.[primaryKey];
                  if(isSelectAllActive.current || selectedRowData.current.has(key)) {
                      node.setSelected(true);
                  }
                });
              }, 0);
              gridRef?.current?.api.setGridOption("loading", false); 
            } else {
              gridRef?.current?.api?.showNoRowsOverlay();
              params.successCallback([], 0);
              gridRef?.current?.api.setGridOption("loading", false); 
              console.warn("No more data available");
              return;
                        }
          }
        }  
      }else if(stream === "simple"){
      
          fetchUrlParams.current.set("limit", pageSize.current.toString());
          fetchUrlParams.current.set("page_state", "0");
      
          const fetchUrlParamsString = "?" + ((fetchUrlParams.current.size > 0) ? fetchUrlParams.current.toString() : "");
          const queryParamsString =  (queryParams.current.size > 0) ? `&${queryParams.current}` : "";
          
          const REQ_URL = `${fetchUrlRef.current}${fetchUrlParamsString}${queryParamsString}`;

          const response = await GenericDassQuery(REQ_URL, { method: "GET" });

          fetchUrlParams.current.delete("limit");
          fetchUrlParams.current.delete("page_state");

          if (response.status === 200) {
            const data = await response.data;
            if (Array.isArray(data) && data.length > 0) {   
              totalEntriesRef.current = data?.length ?? 0;
               data.forEach((row) => {
                  if (dataTableOption.addServiceActions){
                    dataTableOption.actions = dataTableOption.addServiceActions(row);
                  }
                  if (dataTableOption.addBulkServicesActions){
                    dataTableOption.bulkActions = dataTableOption.addBulkServicesActions(row,dataTableOption.bulkActions);   
                  }
                 DataTableContextObj.setSearchState(prev => ({
                   ...prev,
                   dataTableOption: dataTableOption,
                 }));
              });
              params.successCallback(data, totalEntriesRef.current);
              setTimeout(() => {
                gridRef.current?.api?.forEachNode((node) => {
                  const key = node.data?.[primaryKey];
                  if(isSelectAllActive.current || selectedRowData.current.has(key)) {
                    node.setSelected(true);
                  }
                });
              }, 0);
              gridRef?.current?.api.setGridOption("loading", false); 
            } else {
                gridRef?.current?.api?.showNoRowsOverlay();
                params.successCallback([], 0); 
                gridRef?.current?.api.setGridOption("loading", false); 
                console.warn("No more data available");
                return;
            }            
          } else {
            console.log(response)
          }
        }  
      } catch (error) {
        console.error("Data fetch error:", error);
        params.successCallback([], 0); 
      }
      finally {
        gridRef?.current?.api.setGridOption("loading", false); 
      }
    },
  };
  // Block AG Grid header pointer events during sort
  const freezeHeader = (freeze: boolean) => {
    const header = document.querySelector('.ag-header-container');
    if (header) {
      if (freeze) header.classList.add('ag-header-blocked');
      else header.classList.remove('ag-header-blocked');
    }
  };

  const onSortChanged = async (event: SortChangedEvent<unknown, unknown>) => { 
    if (responseLoadingRef.current) return;
    responseLoadingRef.current = true;
    freezeHeader(true);
    try{
      gridRef.current?.api.setGridOption("loading", true);
      sortParamMap.forEach((paramKey) => {
        if (queryParams.current.has(paramKey)) {
          queryParams.current.delete(paramKey); 
        }
      });
      const column = event["columns"]?.[event["columns"]?.length - 1]?.getColId();
      const colName = sortParamMap.get(column ?? "");
      const sort = event["columns"]?.[event["columns"]?.length - 1]?.getSort();
      if (colName && (sort === "desc" || sort === "asc")){  
        queryParams.current.set(colName, sort);
      }
      pageStateArray.current = [];
      await fetchPageState();
    }catch (error) {
      console.error("Data fetch error:", error);
    } finally {
      freezeHeader(false);
      gridRef.current?.api.setGridOption("loading", false);
      responseLoadingRef.current = false;
    }
  };

  const onFilterChanged = async () => {
    try {
      if(isSelectAllActive.current) {
        selectedRowData.current.clear();
        deSelectedRowData.current.clear();
        isSelectAllActive.current = false;
      }
      await gridRef.current?.api.setGridOption("loading", true);
      const gridApi = gridRef?.current?.api;
      const getFilterModel = gridApi?.getFilterModel();
      const filterKeys = Object.keys(getFilterModel ?? {});
      const updatedSearchFields = {};
      searchParamMap?.forEach((paramKey) => {
        paramKey?.forEach((key) => {
          if (queryParams.current.has(key)) {
            queryParams.current.delete(key); 
          }
        })
      });
      if (filterKeys?.length > 0) {
        filterKeys?.forEach((key) => {
          const selectedValue = getFilterModel?.[key]?.filter;
          const paramKey = searchParamMap.get(key);
            if(paramKey?.length > 1) {
              const selectedValueArray = selectedValue.split(',');
              if(paramKey?.length === selectedValueArray?.length) {
                paramKey?.forEach((key, index) => {
                  queryParams.current.set(key ?? "", selectedValueArray[index]);
                  updatedSearchFields[key ?? ""] = selectedValueArray[index];
                });
              }
            }
            else{ 
              const filterValue = selectedValue.trim();
              queryParams.current.set(paramKey?.[0] ?? "", filterValue);
              updatedSearchFields[paramKey?.[0] ?? ""] = filterValue;
            }
        });
      }
      DataTableContextObj.setSearchState(prev => ({
        ...prev,
        searchFields: updatedSearchFields,
      })); 
      await fetchPageState();
    }catch (error) {
      console.error("Data fetch error:", error);
    }
  };

  const onPaginationChanged = async (event: PaginationChangedEvent<unknown, unknown>) => {
    try {
      const newPageSize = event.api.paginationGetPageSize();
      if (pageSize.current !== newPageSize) {
        if(isSelectAllActive.current) {
          selectedRowData.current.clear();
          deSelectedRowData.current.clear();
          isSelectAllActive.current = false;
        }
        gridRef.current?.api.setGridOption("loading", true);
        pageSize.current = newPageSize;
        await fetchPageState();
      }
    }catch (error) {
      console.error("Data fetch error:", error);
    }
  };

  const onColumnVisible = useCallback((event: ColumnVisibleEvent) => {
    try{
      const allColumns = event.api.getAllGridColumns();
      const visibleCols = allColumns.filter(col => col.isVisible());
      const visibleColIds = visibleCols.map(col => col.getColId());
      setVisibleColumnList(visibleColIds);
    }catch (error) {
      console.error("Data fetch error:", error);
    }
  }, []);

  const onColumnResized = (event: ColumnResizedEvent) => {
    try{
      const colId = event.column?.getColId();
      const newWidth = event.column?.getActualWidth();
      if (event.finished && colId && newWidth !== undefined) {
        event.api.refreshCells({
          columns: [event.column.getColId()],
          force: true,
        });
        columnWidthsRef.current.set(colId, newWidth);
      }
    }catch (error) {
      console.error("Data fetch error:", error);
    }  
  };
   
  const onGridReady = async (params: GridReadyEvent) => {
    if (setGridApi) {
      setGridApi(params.api);
    }
    // To initalize column visibility based on visibleColumnList when tableVersionKey changes for apply rowHeightOption
    if (visibleColumnList.length > 0) {
      params.api.setColumnsVisible(visibleColumnList, true);
      const allCols = params.api.getAllGridColumns().map(c => c.getColId());
      const hiddenCols = allCols.filter(c => !visibleColumnList.includes(c));
      params.api.setColumnsVisible(hiddenCols, false);
    }
    if (!pageStateArray.current.length) {
      await fetchPageState();
    }
  };

  const gridOptions: GridOptions = {
    loading: true, 
    rowModelType: stream === 'memory' ? "clientSide" : "infinite",
    cacheBlockSize: pageSize.current,
    paginationPageSize: pageSize.current,
    pagination: pagination,
    paginationPageSizeSelector: paginationPageSizeSelector, 
    onFilterChanged, 
    onSortChanged, 
    onPaginationChanged, 
    onColumnVisible,
    onColumnResized, 
    rowSelection: { 
        mode: 'multiRow', 
        checkboxes: false,
        headerCheckbox: false,
        enableClickSelection: false,
    },
  };

  const theme = useMemo(() => {
    return themeQuartz.withParams({
      spacing: 4,
      rowHeight: rowHeight ?? 35, 
      headerColumnBorderHeight: "0%",
      headerHeight: "2.5em",
      headerTextColor: "black",
      fontSize: "13px",
      fontFamily: "sans-serif", 
      checkboxCheckedShapeColor: "white",     
      checkboxCheckedBorderColor: "black",    
      checkboxCheckedBackgroundColor: "#8e8b8b",  
    });
  }, [rowHeight]);

  useEffect(() => {
    const updateGrid = async () => {
      if (gridRef.current?.api) {
        // Increment the key to force a full re-initialization
        setTableVersionKey(prevKey => prevKey + 1);
        await fetchPageState(); 
      }
    }
    updateGrid();
  }, [rowHeight]);

  return (
    <>
        {
        hasColInitialized && (
        <AgGridReact  
          key={tableVersionKey} // The key changes, forcing a complete component re-creation
          tooltipShowDelay={0}
          tooltipInteraction={true}
          suppressDragLeaveHidesColumns={true} 
          ref={gridRef}
          gridOptions={gridOptions}
          theme={theme}
          onGridReady={onGridReady}
          columnDefs={columnDefs.current}
          suppressNoRowsOverlay={false}
          suppressColumnVirtualisation={true}
          suppressHorizontalScroll={false}
          overlayLoadingTemplate={` <div className="loading-overlay ">
              <img src=${loader} alt="Loading..." width={30} height={50} />
            </div>
         `}
          overlayNoRowsTemplate={`<div className="loading-overlay" style="display: flex; flex-direction: column; justify-content: center; align-items: center; font-family: 'MarkBook', sans-serif;">
              <img src="${noDeviceAvailable}" width="40%" height="40%" />
              <div style="font-size: 12px; margin-top: 16px;">No data available!</div>
          </div>`}
        {
          ...(stream === 'memory' && Array.isArray(dataTableOption?.data) ? 
          { rowData: dataTableOption.data } : {})
        } 
        />)
        } 
    </>
  );
};

export default AGGridDataTableEngine;
 

function toastErrorMessage(error) {
  if (error?.status === 400 || error?.status === 403 || error?.status === 429) {
    toast.error(error.message);
  } else if (error?.status === 402) {
    toast.warning(error.message);
  } else if (error?.status === 404) {
    console.error('No such content');
  } else {
    console.error(`Unexpected status code: ${error.status}`);
  }
}